import { HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Filtro para usar con el { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterPassThruRequest }
 * MEdiante este filtro se especifican en el array las url que no se deben interceptar para inyectar token
 *
 * - Devuelve true si la petición hay que dejarla pasar, no interceptar
 * - Devuelve false si la petición hay que interceptarla
 *
 * @export
 * @param {HttpRequest<any>} req
 * @returns
 */
export function filterPassThruRequest(req: HttpRequest<any>) {
  const passThru = [environment.endPoints.users.login, 'assets/', environment.base_url_esri_10_ava_calles, environment.base_url_esri_10_ava_portales].some((url) =>
    req.url.includes(url)
  );
  return passThru;
}
